import ErrorMessage from "@/components/forms/error-message"
import Input from "@/components/forms/input"
import Label from "@/components/forms/label"
import Logo from "@/components/graphics/logo"
import Auth from "@/layouts/auth"
import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"

import nprogress from 'nprogress'
import axios from "axios"
import { useAuth } from "@/contexts/auth-context"

export default function Login() {
    // Contexts
    const { setSession } = useAuth()

    // Hooks
    const navigate = useNavigate()

    // Forms
    const [email, setEmail] = useState()
    const [password, setPassword] = useState()

    const [errors, setErrors] = useState({})

    const handleSubmit = (e) => {
        e.preventDefault()
        nprogress.start()

        setErrors({})

        axios.post(`${process.env.REACT_APP_API_URL}/login`, {
            email,
            password
        }).then((response) => {
            setSession(response.data.token, response.data.user)
            // if (location.state?.back) {
            //     if (location.state?.back !== '/no-role' && location.state?.back !== '/branch/select' && location.state?.back !== location.pathname) {
            //         navigate(location.state?.back ?? 0)
            //     } else {
            //         navigate(0)
            //     }
            // } else {
            //     navigate(0)
            // }
            // toast.success(response.data.message)
            navigate(0)
            nprogress.done()
        }).catch((error) => {
            if (error.response?.status === 422) {
                setErrors(error.response?.data.errors)
            }
            // toast.error(error.response?.data.message)
            console.log(error)
            nprogress.done()
        })
    }

    return (
        <>
            <Auth title="Login">
                <div className="flex items-center justify-center w-full px-4 py-12 sm:px-6 lg:px-8">
                    <div className="w-full max-w-md space-y-8">
                        <div>
                            <div className="flex justify-center">
                                <div className="p-4 text-white rounded-full bg-neutral-800">
                                    <Logo className="w-8 h-8" strokeWidth={3} />
                                </div>
                            </div>
                            <h2 className="mt-6 text-3xl font-bold tracking-tight text-center text-gray-900">
                                Hello, there!
                            </h2>
                            <p className="mt-2 text-sm text-center text-neutral-600">
                                Please sign-in with your account.
                            </p>
                        </div>
                        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                            <div className="space-y-4">
                                <div>
                                    <Label htmlFor="email" value="Email" />
                                    <Input onChange={(e) => setEmail(e.target.value)} value={email} error={errors.email} id="email" type="email" />
                                    <ErrorMessage error={errors.email} />
                                </div>

                                <div>
                                    <Label htmlFor="password" value="Password" />
                                    <Input onChange={(e) => setPassword(e.target.value)} value={password} error={errors.password} id="password" type="password" />
                                    <ErrorMessage error={errors.password} />
                                </div>

                                <div className="flex justify-between text-xs">
                                    {/* <div className="flex items-end">
                                        <div>
                                            <Checkbox onChange={handleChangeRemember} checked={remember} id="remember_me" name="remember_me" error={errors.remember_me} />
                                        </div>
                                        <div className="ml-2">
                                            <label htmlFor="remember_me">
                                                Remember Me
                                            </label>
                                        </div>
                                    </div> */}
                                    <span>Don't have an account? Sign up <Link to="/register" className="underline underline-offset-2">here</Link>.</span>
                                </div>
                            </div>
                            <div>
                                <button type="submit" className="items-center w-full px-6 py-3 text-sm text-white transition bg-neutral-800 rounded-xl active:hover:scale-90">
                                    <span>Sign in</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Auth>
        </>
    )
}